export default __webpack_public_path__ + "static/lou-mousset-0053e5b0afcb77f34155a6a6ad83da11.png";